import { memo } from "react";

import { getImageUrl } from "@/lib/aws-amplify/host-storage";
import { convertToJapaneseYearMonthDay } from "@/lib/dayjs/convert/convert-to-japanese-year-month-day";
import type { VoucherIssuedForCampaignListByHotelIdAndVoucherId_DetailsPageQuery } from "@/lib/gql/__generated__/graphql";

import { Image } from "@/components/ui/image/image";

type Props = {
	voucherForCampaign: VoucherIssuedForCampaignListByHotelIdAndVoucherId_DetailsPageQuery["voucherForCampaign"];
	voucherIssuedForCampaignList: VoucherIssuedForCampaignListByHotelIdAndVoucherId_DetailsPageQuery["voucherIssuedForCampaignListByHotelIDAndVoucherID"]["voucherIssuedForCampaignList"];
};

export const CampaignDetailsInnerHeader = memo(({ voucherForCampaign, voucherIssuedForCampaignList }: Props) => {
	const { name, mainKeyVisual, description, cinStart, cinEnd, resourceAvailablePrice, voucherPrice } =
		voucherForCampaign;

	// 発行枚数
	const issuedCount = voucherIssuedForCampaignList.length;
	// 利用済み枚数
	const usedCount = voucherIssuedForCampaignList.filter((item) => item.usedAt || item.usedReservationID).length;
	const usedCountText = `${usedCount} / ${issuedCount}`;

	// チェックインが可能な期間
	const cInAndCOutDateText = `${convertToJapaneseYearMonthDay(cinStart)} 〜 ${convertToJapaneseYearMonthDay(cinEnd)}`;

	// 適用価格
	const priceText = `${resourceAvailablePrice.amount.toLocaleString()} 円以上の予約で、${voucherPrice.amount.toLocaleString()} 円割引`;

	const mainKeyVisualUrl = getImageUrl(mainKeyVisual);

	return (
		<div className="flex flex-col gap-y-4 laptop:flex-row laptop:gap-x-8">
			<div>
				<Image src={mainKeyVisualUrl} className="aspect-video w-full laptop:w-56" />
			</div>
			<div className="flex-1 space-y-6">
				<div className="flex flex-col gap-y-3">
					<h4 className="text-xl font-semibold">{name}</h4>
					<p>{description}</p>
				</div>

				<div className="grid grid-cols-1 gap-x-8 gap-y-4 laptop:grid-cols-2 [&>div>h6]:text-sm [&>div>p]:ml-4">
					<div>
						<h6>宿泊（チェックイン）可能な期間</h6>
						<p>{cInAndCOutDateText}</p>
					</div>
					<div>
						<h6>使用枚数 / 発行枚数</h6>
						<p>{usedCountText}</p>
					</div>
					<div>
						<h6>割引金額</h6>
						<p>{priceText}</p>
					</div>
				</div>
			</div>
		</div>
	);
});

CampaignDetailsInnerHeader.displayName = "CampaignDetailsInnerHeader";
